var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-settings-page"},[_vm._t("tabs"),_vm._v(" Billing settings ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }